import { Pipe, PipeTransform } from '@angular/core';

type ControlErrorValue = {
  requiredLength?: number;
  [key: string]: unknown;
};

@Pipe({
  name: 'controlErrorMessage',
  standalone: true,
})
export class ControlErrorMessagePipe implements PipeTransform {
  transform(error: { key: string; value: ControlErrorValue }): string {
    const errorMessages: Record<string, string> = {
      required: 'Este campo es requerido.',
      email: 'Debe ser un formato válido de email.',
      minlength: `Debe tener al menos ${error.value.requiredLength} caracteres de largo.`,
      maxlength: `Debe tener como máximo ${error.value.requiredLength} caracteres.`,
      amountNotPositive: 'El monto debe ser mayor a cero.',
      passwordMismatch: 'Las contraseñas no coinciden.',
      invalidPlate: 'Formato de patente inválido. Ej: ABC123 o AB123CD',
      invalidCustomer: 'No es un cliente válido.',
      invalidBarcode: 'El código de barras es incorrecto.',
      pattern:
        'El valor ingresado no cumple con el formato permitido. Solo letras, números, guiones y puntos. Mínimo 6 caracteres y Máximo 20.',
    };
    return errorMessages[error.key] || 'Campo inválido';
  }
}
